import React from 'react';
import InfoPage, { Section } from '../../components/InfoPage';
import { Truck, MapPin, Clock, RotateCcw } from 'lucide-react';

const Shipping = () => (
  <InfoPage title="Shipping policy" lastUpdated="March 1, 2026">
    <p>
      We ship fast because we know you're ready to start your ritual. Here's exactly what to expect.
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {[
        { icon: Clock, t: 'Processing', d: 'Orders ship within 1–2 business days.' },
        { icon: Truck, t: 'Delivery', d: '6–9 business days within the US after dispatch.' },
        { icon: MapPin, t: 'International', d: '10–18 business days. Taxes/duties may apply locally.' },
        { icon: RotateCcw, t: 'Free shipping', d: 'Automatic on US orders over $40.' },
      ].map((b) => {
        const Icon = b.icon;
        return (
          <div key={b.t} className="p-5 rounded-2xl flex items-start gap-3" style={{ backgroundColor: '#F5EDE0' }}>
            <Icon size={22} color="#2D5A3D" />
            <div>
              <p className="font-semibold text-[15px]" style={{ color: '#2C2418' }}>{b.t}</p>
              <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>{b.d}</p>
            </div>
          </div>
        );
      })}
    </div>

    <Section heading="Tracking your order">
      <p>
        You'll get an email with a tracking link within 24 hours of dispatch. You can also check status anytime on our
        Track Your Order page.
      </p>
    </Section>

    <Section heading="Lost or stuck packages">
      <p>
        Carrier scans can be delayed. If your order hasn't moved in 7 business days, email our team with your order number and we'll open a case immediately.
      </p>
    </Section>

    <Section heading="Address mistakes">
      <p>
        Reach out within 4 hours of placing your order if you spot a typo. After that, we may already be packing it.
      </p>
    </Section>
  </InfoPage>
);

export default Shipping;
